var map = {
	"./admin-icon-color.png": "3d62",
	"./crm-field service-color.png": "cfd6",
	"./crm-sales-color.png": "eba0",
	"./ecom.png": "97cd",
	"./empty-record.png": "366d",
	"./expense-color.png": "9904",
	"./help-desk-color2.png": "e779",
	"./hr-color.png": "a134",
	"./icons8-renew-96.png": "3d2f",
	"./invoice.png": "ef49",
	"./mcp-color.png": "fe1d",
	"./page-500.png": "c24f",
	"./payroll.png": "5ec0",
	"./pos-color.png": "aafd",
	"./sales-color.png": "2a28"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1872";